module.exports = __webpack_public_path__ + "assets/img/7.5a3c5351.gif";